import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { ExpandingWildsBulkFactory , ExpandingWildsBulk , ExpandingWildsBulkParam, ExpandingWildsBulkConfig } from "../ExpandingWildBulk";
import { Rect } from "../../MyHelpers";
//namespace SlotGames {
	export class RoyalKingDeluxe10_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

		
		protected override helpFactory: IHelpFactory = new RoyalKingDeluxe10HelpFactory();
        protected override expandingWildsFactory: ExpandingWildsBulkFactory = new RoyalKingDeluxe10ExpandingWildsBulkFactory();
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "RoyalKingDeluxe10");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
		// }
	        //SEND COLOR 
			protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

    }

    //Help Colorized
    class RoyalKingDeluxe10HelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new RoyalKingDeluxe10Help(params);
        }
    }

    class RoyalKingDeluxe10Help extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
    class RoyalKingDeluxe10ExpandingWildsBulkFactory extends ExpandingWildsBulkFactory
	{
		public override CreateExpandingWildsBulk(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig): ExpandingWildsBulk 
		{
			return new RoyalKingDeluxe10ExpandingWildsBulk(param, config);
		}

	}

    class RoyalKingDeluxe10ExpandingWildsBulk extends ExpandingWildsBulk
	{
		public override InflateWildSize(wildRect: Rect): Rect
		{
			return wildRect;
		}
	}
//}
